import { getCountryGroup, GREAT, LATAM } from "./CountryGroups";
import { arrayIncludesNumber } from "./toolsHelper";

/**
 * @typedef {Object} BenefitOption
 * @property {Number} id
 * @property {(contextState) => boolean|boolean} ignored
 */

/**
 * @type {BenefitOption[]}
 */
export const benefitOptions = [
  {
    id: "lalted",
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "wwide"
      );
    },
  },
  {
    id: "laopen",
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "wwide"
      );
    },
  },
  {
    id: 77,
    ignored: true,
  },
  {
    id: "gllted",
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "latam"
      );
    },
  },
  {
    id: "glopen",
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "latam"
      );
    },
  },
  {
    id: 101,
    ignored: true,
  },
  {
    id: 34,
    ignored: true,
  },
  {
    id: 129,
    ignored: true,
  },
  {
    id: 126,
    ignored: true,
  },
  {
    id: 81,
    ignored: true,
  },
  {
    id: 97,
    ignored: true,
  },
  {
    id: 150,
    ignored: true,
  },
  {
    id: 210,
    ignored: true,
  },
  {
    id: 149,
    ignored: true,
  },
  {
    id: 216,
    ignored: true,
  },
  {
    id: 73,
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "coinsurance_no"
      );
    },
  },
  {
    id: 72,
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "coinsurance_no"
      );
    },
  },
  {
    id: 71,
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "coinsurance_no"
      );
    },
  },
  {
    id: 70,
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "coinsurance_no"
      );
    },
  },
  {
    id: 69,
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "coinsurance_no"
      );
    },
  },
  {
    id: 68,
    ignored: (contextState) => {
      return arrayIncludesNumber(
        Object.values(contextState.selectedBenefitsIds),
        "coinsurance_no"
      );
    },
  },
  {
    id: "wwide",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "maxcovpipoly_500000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_2000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_3500"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_5000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_3500"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_2000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_5000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_3500",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_5000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_2000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_10000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_3500",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_10000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_5000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_10000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_2000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_20000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_3500",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_20000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_5000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_20000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_3500",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_500"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_5000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_500"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_3500",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_1000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_5000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_1000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_3500",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_2000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "maxcoinoop_5000",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_2000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "coinsurance_50",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_50000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "coinsurance_20",
    ignored: (contextState) => {
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "dednonusa_50000"
        )
      ) {
        return true;
      }
      return false;
    },
  },
  {
    id: "latam",
    ignored: (contextState) => {
      let ignored = false;
      if (contextState.addDependant) {
        for (const dependant of contextState.dependants) {
          if (arrayIncludesNumber(getCountryGroup(GREAT).list, dependant.country)) {
            ignored = true;
          }
        }
      }
      return ignored;
    },
  },
  {
    id: "wwltd",
    ignored: (contextState) => {
      let ignored = false;
      if (
        arrayIncludesNumber(
          Object.values(contextState.selectedBenefitsIds),
          "maxcovpipoly_500000"
        )
      ) {
        return true;
      }
      if (contextState.addDependant) {
        for (const dependant of contextState.dependants) {
          if (arrayIncludesNumber(getCountryGroup(GREAT).list, dependant.country)) {
            ignored = true;
          }
          if (["76"].includes(dependant.country)) { // Validación para dependientes de Brazil
            ignored = true;
          }
        }
      }
      return ignored;
    },
  },
  {
    id: "maxcovpipoly_500000",
    ignored: (contextState) => {
      let ignored = true;
      if (
        arrayIncludesNumber(getCountryGroup(LATAM).list, contextState.country)
      ) {
        ignored = false;
      }
      if (contextState.addDependant) {
        for (const dependant of contextState.dependants) {
          if (arrayIncludesNumber(getCountryGroup(GREAT).list, dependant.country)) {
            ignored = true;
          }
        }
      }
      return ignored;
    },
  },
].map((i) => {
  if (!i?.ignored) i.ignored = false;
  return i;
});
